import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from '../pages/home/Home';
import SerachResult from '../pages/searchResult/SearchResult';
import MyBooking from '../pages/myBookings/MyBookings';
import Blog from '../pages/blog/Blog';
import BlogDetails from '../pages/blogDeatils/BlogDetails';
import ContactUs from '../pages/contactUs/ContactUs';
import MyWishlist from '../pages/myWishlist/MyWishlist';
import TripDetails from '../pages/tripDetails/TripDetails';
import AyurDetails from '../pages/ayurDetails/AyurDetails';
import CampDetails from '../pages/campDetails/CampDetails';
import ReviewBooking from '../pages/reviewBooking/ReviewBooking';
import { UserLoginSecProvider } from '../context/UserLoginSecContext';
import { UserAuthProvider } from '../context/UserAuthContext';
import Header from '../webPageSections/header/Header';
import Footer from '../webPageSections/footer/Footer';
import { BookingDataProvider } from '../context/BookingDataContext';
import Account from '../pages/account/Account';
import BookingConfirmation from '../pages/bookingConfirmation/bookingConfirmation';
import AboutUs from '../pages/aboutUs/AboutUs';
import Terms from '../pages/terms/Terms';
import Privacy from '../pages/privacy/Privacy';
import Cancellation from '../pages/cancellation/Cancellation';
import Faq from '../pages/faq/Faq';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Rating from '../pages/tripRating/rateTrip';
import ScrollToTop from '../components/scrollTop/ScrollTop';
import PackageGridDetails from '../pages/packageGrid/packageGridDetails';
import MyReviews from '../pages/myReviews/MyReviews';
import CustomFooter from '../webPageSections/footer/orgFooter/CustomFooter';
import CustomHeader from '../webPageSections/header/orgHeader/CustomHeader';
import { useTempOrg } from '../context/TempOrgContext';
import PaymentPending from '../pages/paymentStatus/PaymentPending';
import VerifyPayment from '../components/payment/verifyPayment';
import OffersDetails from '../pages/OffersDetails/OffersDetails';
import SpecialOffers from '../pages/specialOffers/SpecialOffers';
import OffersProvider from '../context/OffersContext';
import SearchResultCamp from '../pages/searchResultCamp/SearchResultCamp';
import SearchResultActivity from '../pages/searchResultActivity/SearchResultActivity';
import ActivityDetails from '../pages/activityDetails/ActivityDetails';
import SerachResultGuide from '../pages/searchResultGuide/SearchResultGuide';
import GuideDetails from '../pages/guideDetails/GuideDetails';
import ReviewBookingOthers from '../pages/reviewBookingOthers/ReviewBookingOthers';
import ReviewBookingCamp from '../pages/reviewBookingCamp/ReviewBookingCamp';

const userClearItems = ['name', 'uaerId', 'token', 'expiry', 'user'];

export default function UserLayout() {
    const location = useLocation();
    const [isScrolled, setIsScrolled] = useState(false);
    const isLoginExpired = () => {
        const expiryTime = Number(window.localStorage.getItem('expiry'));
        return expiryTime && Date.now() > expiryTime;
    };

    const isOrgRoute = location.pathname.startsWith('/orgid');
    const { tempOrg } = useTempOrg();
    // const [tempOrg, setTempOrg] = useState(() => {
    //     // Read from localStorage initially
    //     const stored = localStorage.getItem('tempOrg');
    //     return stored ? JSON.parse(stored) : {};
    // });

    // useEffect(() => {
    //     const channel = new BroadcastChannel('org_channel');

    //     channel.onmessage = (event) => {
    //         if (event.data.type === 'UPDATE_ORG') {
    //             setTempOrg(event.data.payload);
    //         } else if (event.data.type === 'REMOVE_ORG') {
    //             setTempOrg({});
    //         }
    //     };

    //     return () => channel.close();
    // }, [tempOrg?.id]);

    // // Optional: listen to storage changes from other tabs
    // useEffect(() => {
    //     const handleStorageChange = (event) => {
    //         if (event.key === 'tempOrg') {
    //             try {
    //                 setTempOrg(JSON.parse(event.newValue) || {});
    //             } catch {
    //                 setTempOrg({});
    //             }
    //         }
    //     };
    //     window.addEventListener('storage', handleStorageChange);
    //     return () => window.removeEventListener('storage', handleStorageChange);
    // }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            if (isLoginExpired()) {
                toast.error('Session has expired. Login again to continue');
                userClearItems.forEach((key) => localStorage.removeItem(key));
                clearInterval(interval);
                setTimeout(() => (window.location.href = '/'), 2000);
            }
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (location.pathname !== '/booking-confirmation') {
            localStorage.removeItem('bookingData');
            localStorage.removeItem('userData');
            localStorage.removeItem('reserveId');
        }
    }, [location.pathname]);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 450) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    //tracking code - meta and google only for userside
    useEffect(() => {
        // <!-- Meta Pixel Code -->

        // If already loaded, skip
        if (window.fbq) return;

        (function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

        // Initialize Pixel
        window.fbq('init', '614331245018381');
        window.fbq('track', 'PageView');
        // (<noscript>
        //     <img
        //         height='1'
        //         width='1'
        //         style='display: none'
        //         src='https://www.facebook.com/tr?id=614331245018381&ev=PageView&noscript=1'
        //     />
        // </noscript>)
        // <!-- End Meta Pixel Code -->

        // <!-- Clarity microsoft start -->

        (function (c, l, a, r, i, t, y) {
            c[a] =
                c[a] ||
                function () {
                    (c[a].q = c[a].q || []).push(arguments);
                };
            t = l.createElement(r);
            t.async = 1;
            t.src = 'https://www.clarity.ms/tag/' + i;
            y = l.getElementsByTagName(r)[0];
            y.parentNode.insertBefore(t, y);
        })(window, document, 'clarity', 'script', 'serutpi01i');
        // <!-- Clarity microsoft end -->

        //    <!-- Google Tag Manager -->
        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l !== 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-W8ZBJQ9X');
        // <noscript>
        //     <iframe
        //         src='https://www.googletagmanager.com/ns.html?id=GTM-W8ZBJQ9X'
        //         height='0'
        //         width='0'
        //         style='display: none; visibility: hidden'
        //     ></iframe>
        // </noscript>;
        // <!-- End Google Tag Manager -->
    }, []);

    useEffect(() => {
        // GMT page tracker
        // if (window.dataLayer) {
        //     window.dataLayer.push({
        //         event: 'page_view',
        //         page_path: location.pathname,
        //         page_location: window.location.href,
        //         page_title: document.title
        //     });
        // }

        // Facebook Pixel page tracker
        if (window.fbq) {
            window.fbq('track', 'PageView');
        }
    }, [location.pathname]);

    return (
        <>
            <UserAuthProvider>
                <UserLoginSecProvider>
                    <BookingDataProvider>
                        <OffersProvider>
                            {location.pathname === '/' || location.pathname.startsWith('/search-result') ? (
                                <Header isScrolled={isScrolled} />
                            ) : isOrgRoute ? null : tempOrg?.id ? (
                                <CustomHeader
                                    leftItems={['logo']}
                                    logo={tempOrg?.orgLogo}
                                    companyName={tempOrg?.orgName}
                                    rightItems={['login', 'signup', 'menuIcons']}
                                />
                            ) : (
                                <Header isScrolled={isScrolled} />
                            )}
                            <ScrollToTop />
                            <Routes>
                                <Route path='/' element={<Home />} />
                                <Route path='/home' element={<Home />} />
                                <Route path='/offers' element={<OffersDetails />} />
                                <Route path='/special-offers' element={<SpecialOffers />} />
                                <Route path='/:type' element={<Home />} />
                                <Route path='/trip/details/:id' element={<TripDetails />} />
                                <Route path='/ayur/details/:id' element={<AyurDetails />} />
                                <Route path='/camp/details/:id' element={<CampDetails />} />
                                <Route path='/act/details/:id' element={<ActivityDetails />} />
                                <Route path='/gu/details/:id' element={<GuideDetails />} />
                                <Route path='/search-result/:type/:text?' element={<SerachResult />} />
                                {/* <Route path='/search-result/camp' element={<SearchResultCamp />} />
                                <Route path='/search-result/act' element={<SearchResultActivity />} />
                                <Route path='/search-result/gu/:text' element={<SerachResultGuide />} /> */}
                                <Route path='/my-booking' element={<MyBooking />} />
                                <Route path='/my-reviews' element={<MyReviews />} />
                                <Route path='/my-wishlist' element={<MyWishlist />} />
                                <Route path='/blog' element={<Blog />} />
                                <Route path='/blog/details/:id' element={<BlogDetails />} />
                                <Route path='/trip/review-booking' element={<ReviewBooking />} />
                                <Route path='/camp/review-booking' element={<ReviewBookingCamp />} />
                                <Route path='/:type?/review-booking' element={<ReviewBookingOthers />} />
                                <Route path='/account' element={<Account />} />
                                <Route path='/about-us' element={<AboutUs />} />
                                <Route path='/contact-us' element={<ContactUs />} />
                                <Route path='/terms' element={<Terms />} />
                                <Route path='/review/:type/:phone/:id' element={<Rating />} />
                                <Route path='/privacy-policy' element={<Privacy />} />
                                <Route path='/cancellation-policy' element={<Cancellation />} />
                                <Route path='/faq' element={<Faq />} />
                                <Route path='/payment-verification' element={<VerifyPayment />} />
                                <Route path='/payment-pending' element={<PaymentPending />} />
                                <Route path='/booking-confirmation' element={<BookingConfirmation />} />
                                <Route path='/orgid/:id' element={<PackageGridDetails />} />
                                <Route path='/*' element={<Navigate to='/' />} />
                                {/* <Route path="/" element={<Navigate to="/admin/home"/>} /> */}
                                {/* <Route path="/" element={<Home />} /> */}
                            </Routes>
                        </OffersProvider>
                    </BookingDataProvider>
                </UserLoginSecProvider>
            </UserAuthProvider>
            {location.pathname === '/' || location.pathname.startsWith('/search-result') ? (
                <Footer />
            ) : isOrgRoute || tempOrg.id ? (
                <CustomFooter />
            ) : (
                <Footer />
            )}
        </>
    );
}
